import clsx from "clsx";
import { Button, type ButtonProps } from "@/components/ui/Button";
import type { ReactNode } from "react";

export function TimesheetFlowFooter({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <footer
      className={clsx(
        "mt-3 flex shrink-0 flex-col-reverse gap-2 border-t border-separator bg-card pt-3",
        "sm:flex-row sm:flex-wrap sm:justify-end",
        className,
      )}
    >
      {children}
    </footer>
  );
}

export function TimesheetFlowFooterButton({ className, ...props }: ButtonProps) {
  return <Button {...props} className={clsx("w-full sm:w-auto", className)} />;
}
